import Dexie, { Table } from 'dexie';
import { AreaMap } from '../domain/area-map';
import { Cassette } from '../domain/cassette';
import { MaterielEau } from '../domain/EAU/materiel-eau';
import { MeasureEau } from '../domain/EAU/measure-eau';
import { ESamplingMode } from '../domain/enums/sampling-mode';
import { GlobalTask } from '../domain/global-task';
import { Intervention } from '../domain/intervention';
import { MeasureLingette } from '../domain/Lingette/measure-lingette';
import { MeasureMassif } from '../domain/Massif/measure-massif';
import { MeanOfPrevention } from '../domain/mean-of-prevention';
import { MPCA } from '../domain/mpca';
import { Operator } from '../domain/operator';
import { PlageHoraire } from '../domain/plage-horaire';
import { Pompe } from '../domain/pompe';
import { Process } from '../domain/process';
import { ProcessCalculation } from '../domain/process-calculation';
import { ProcessMeasure } from '../domain/process-mesure';
import { ProcessSamplingCondition } from '../domain/process-sampling-condition';
import { ProcessTechnique } from '../domain/process-technique';
import { PointageJournalier } from '../domain/RH/pointage-journalier';
import { PointagePause } from '../domain/RH/pointage-pause';
import { SamplingPoint } from '../domain/sampling-point';
import { Securite } from '../domain/securite';
import { Task } from '../domain/task';
import { User } from '../domain/user';
import { Zone } from '../domain/zone';
import { ZoneMeasure } from '../domain/zone-measure';
import { ZoneSamplingCondition } from '../domain/zone-sampling-condition';
import { mapper } from '../tools/mapping/mapper';
import { ColorService } from '../tools/ui/color.service';
// @ts-expect-error Package does not provide TypeScript declarations.
import IDBExportImport from 'indexeddb-export-import';
import * as _ from 'lodash'
import { MesureAdduction } from '../domain/Adduction-air/mesure-adduction';
import { MesureAdductionDTO } from '../services/dto/mesure-adduction.dto';
import { MaterielAdduction } from '../domain/Adduction-air/materiel-adduction';
import { PrelevementAir } from '../domain/Adduction-air/prelevement-air';
import { MeasureGeneric } from '../domain/measure-generic';
import {
    AreaMapEntity,
    CassetteEntity,
    GlobalTaskEntity,
    InterventionEntity,
    MeasureEauEntity,
    MeasureEntity,
    MeasureGenericEntity,
    MeasureLingetteEntity,
    MeasureMassifEntity,
    MaterielAdductionEntity,
    MaterielEauEntity,
    MeanOfPreventionEntity,
    MesureAdductionEntity,
    MPCAEntity,
    OperatorEntity,
    PointageJournalierEntity,
    PointagePauseEntity,
    PompeEntity,
    PrelevementAirEntity,
    PlageHoraireEntity,
    ProcessCalculationEntity,
    ProcessEntity,
    ProcessMeasureEntity,
    ProcessSamplingConditionEntity,
    ProcessTechniqueEntity,
    SamplingPointEntity,
    SecuriteEntity,
    TaskEntity,
    UserEntity,
    ZoneEntity,
    ZoneSamplingConditionEntity
} from './entity';
import { InterventionRepository } from './repository/intervention.repository';
import { UserRepository } from './repository/user.repository';
import { SamplingPointRepository } from './repository/sampling-point.repository';
import { ZoneRepository } from './repository/zone.repository';
import { ZoneMeasureRepository } from './repository/zone-measure.repository';
import { CassetteRepository } from './repository/cassette.repository';
import { MpcaRepository } from './repository/mpca.repository';
import { ZoneSamplingConditionRepository } from './repository/zone-sampling-condition.repository';
import { PlageHoraireRepository } from './repository/plage-horaire.repository';
import { PompeRepository } from './repository/pompe.repository';
import { ProcessRepository } from './repository/process.repository';
import { MeanOfPreventionRepository } from './repository/mean-of-prevention.repository';
import { ProcessCalculationRepository } from './repository/process-calculation.repository';
import { ProcessTechniqueRepository } from './repository/process-technique.repository';
import { ProcessMeasureRepository } from './repository/process-measure.repository';
import { GlobalTaskRepository } from './repository/global-task.repository';
import { ProcessSamplingConditionRepository } from './repository/process-sampling-condition.repository';
import { OperatorRepository } from './repository/operator.repository';
import { TaskRepository } from './repository/task.repository';
import { SecuriteRepository } from './repository/securite.repository';
import { PointageRepository } from './repository/pointage.repository';
import { AreaMapRepository } from './repository/area-map.repository';
import { MeasureMassifRepository } from './repository/measure-massif.repository';
import { MeasureEauRepository } from './repository/measure-eau.repository';
import { MeasureLingetteRepository } from './repository/measure-lingette.repository';
import { MeasureAdductionRepository } from './repository/measure-adduction.repository';
import { MaterielAdductionRepository } from './repository/materiel-adduction.repository';
import { PrelevementAirRepository } from './repository/prelevement-air.repository';
import { MeasureGenericRepository } from './repository/measure-generic.repository';

export * from './entity';

export class AppDB extends Dexie {
    public interventionRepository!: InterventionRepository;
    public userRepository!: UserRepository;
    public samplingPointRepository!: SamplingPointRepository;
    public zoneRepository!: ZoneRepository;
    public zoneMeasureRepository!: ZoneMeasureRepository;
    public cassetteRepository!: CassetteRepository;
    public mpcaRepository!: MpcaRepository;
    public zoneSamplingConditionRepository!: ZoneSamplingConditionRepository;
    public plageHoraireRepository!: PlageHoraireRepository;
    public pompeRepository!: PompeRepository;
    public processRepository!: ProcessRepository;
    public meanOfPreventionRepository!: MeanOfPreventionRepository;
    public processCalculationRepository!: ProcessCalculationRepository;
    public processTechniqueRepository!: ProcessTechniqueRepository;
    public processMeasureRepository!: ProcessMeasureRepository;
    public globalTaskRepository!: GlobalTaskRepository;
    public processSamplingConditionRepository!: ProcessSamplingConditionRepository;
    public operatorRepository!: OperatorRepository;
    public taskRepository!: TaskRepository;
    public securiteRepository!: SecuriteRepository;
    public pointageRepository!: PointageRepository;
    public areaMapRepository!: AreaMapRepository;
    public measureMassifRepository!: MeasureMassifRepository;
    public measureEauRepository!: MeasureEauRepository;
    public measureLingetteRepository!: MeasureLingetteRepository;
    public measureAdductionRepository!: MeasureAdductionRepository;
    public materielAdductionRepository!: MaterielAdductionRepository;
    public prelevementAirRepository!: PrelevementAirRepository;
    public measureGenericRepository!: MeasureGenericRepository;
    public interventions!: Table<InterventionEntity, number>;
    public users!: Table<UserEntity, number>;
    public samplingPoints!: Table<SamplingPointEntity, number>;

    public zones!: Table<ZoneEntity, number>;
    public mpcas!: Table<MPCAEntity, number>;
    public mesures!: Table<MeasureEntity, number>;
    public zoneSamplingConditions!: Table<ZoneSamplingConditionEntity, number>;

    public measureGeneric!: Table<MeasureGenericEntity, number>;
    public measureEau!: Table<MeasureEauEntity, number>;
    public materielEau!: Table<MaterielEauEntity, number>;
    public measureMassif!: Table<MeasureMassifEntity, number>;
    public measureLingette!: Table<MeasureLingetteEntity, number>;

    public measureAdduction!: Table<MesureAdductionEntity, number>;
    public materielAdduction!: Table<MaterielAdductionEntity, number>;
    public prelevementAir!: Table<PrelevementAirEntity, number>;

    public areaMaps!: Table<AreaMapEntity, number>;
    public securites!: Table<SecuriteEntity, number>;

    public process!: Table<ProcessEntity, number>;
    public meanOfPreventions!: Table<MeanOfPreventionEntity, number>;
    public processCalculations!: Table<ProcessCalculationEntity, number>;
    public processTechniques!: Table<ProcessTechniqueEntity, number>;

    public globalTasks!: Table<GlobalTaskEntity, number>;
    public processMeasures!: Table<ProcessMeasureEntity, number>;
    public processSamplingConditions!: Table<ProcessSamplingConditionEntity, number>;
    public operators!: Table<OperatorEntity, number>;
    public tasks!: Table<TaskEntity, number>;

    public cassettes!: Table<CassetteEntity, number>;
    public plageHoraires!: Table<PlageHoraireEntity, number>;
    public pompes!: Table<PompeEntity, number>;

    public pointageJournaliers!: Table<PointageJournalierEntity, number>;
    public pointagePauses!: Table<PointagePauseEntity, number>;

    constructor() {
        super('GSP1');
        this.version(8).stores({
            interventions: '++Id, Code, Status, RequiredOn, PlannedOn, RequiredTimeSlot, PlannedOnSlot, Comment, SamplerId, ContactId, SamplingPointId, *ZoneIds, *ProcessIds, *LingetteIds, *EauIds, *MassifIds, *AdductionIds, *GenericIds, AreaMapId, StrategyId, Redactor, ClientName, *LingetteAreaMapTerrainIds',
            samplingPoints: '++Id, Code, Name, Address, City, ZipCode',

            users: '++Id, Email, FirstName, LastName, Phone',

            areaMaps: '++Id, Legend, Comment, JsonContent, BackgroundPicture, Data',

            zones: '++Id, Code, Position, Description, CustomerReference, Type, Usage, BuildingType, BuildingTypeNonStandard, RoomUsage, RoomUsageNonStandard, ActivitySimulation, Observation, IsDepose, OnSiteProtectionAndSealingType, *MPCAIds, *MeasureIds, *AreaMapIds',
            mpcas: '++Id, Code, ScolaMaterial, DegradationLevel',
            mesures: '++Id, Code, Status, Localisation, MeasureReferenceCode, MeasureReferenceName, MeasureReferenceDesignation, HasFan, Observation, Color, TextColor, PumpWithBattery, IsDepose, IsCancelled, CassetteId, PoseSecuriteId, DePoseSecuriteId, SamplingConditionId',
            zoneSamplingConditions: '++Id, VitesseVent, Meteo, Hygrometrie, ExpositionClimatique',

            measureMassif: '++Id, Code, IsCancelled, SamplingTime, Localisation, SamplingID, ScolaMaterial, PrelevementEffectue, Observation, ProcessMesureTerrainCode, Position',
            measureLingette: '++Id, Code, IsCancelled, SamplingTime, Localisation, SamplingID, TypeSurface, ReferenceLot, Temoin, VisibilitePoussiere, SurfacePrelevement, Contexte, ApresNettoyage, Status, Position',
            measureEau: '++Id, Code, IsCancelled, SamplingTime, Localisation, SamplingID, MaterielEauId, Observation, TakeAnotherDay',
            materielEau: '++Id, Type, Reference, NombreDouche, DateChangementFiltre, LocalisationRejet, Materiau, Observation, Position',

            measureGeneric: 'Id++, Code, Name, GroupName, Reference, Observation, Number, BatchCode, IsPrestationAnnexe',

            measureAdduction: 'Id++, Code, Date, Localisation, SamplingID, Observation, AppareilMesure, *MaterielAdductionIds, *PrelevementAirIds, IsCancelled, Position',
            materielAdduction: 'Id++, Type, Fabricant, Description, Reference, ReferenceHuile',
            prelevementAir: 'Id++, Type, ReferenceTube, Duree, Resultat, Conformite',

            process: '++Id, Code, Name, CustomerReference, VentilationGlobale, Type, DustLevel, DustLoadType, SubSection, Observation, VolumeRenouvellementAir, MeasureId, *ProcessTechniqueIds, *GlobalTaskIds, ProcessCalculationId, *MeanOfPreventionIds, AreaMapId',
            meanOfPreventions: '++Id, Name',
            processTechniques: '++Id, ScolaTechnique, Humidification, HumidityWork, Catchment, MPCAId',
            processCalculations: '++Id, Duration, SamplingMode',
            globalTasks: '++Id, Position, Description',
            processMeasures: '++Id, Code, MeasureReferenceCode, MeasureReferenceName, MeasureReferenceDesignation, Status, Localisation, TextColor, Color, SamplingID, Observation, IsCancelled, ProcessSamplingConditionId, *OperatorIds, SecuriteId',

            processSamplingConditions: '++Id, APR, Temoin, Hygrometrie1, Hygrometrie2, Hygrometrie3, VitesseVent1, VitesseVent2, VitesseVent3, Meteo, ExpositionClimatique',
            operators: '++Id, Position, FirstName, LastName, *CassetteIds, *TaskIds',
            tasks: '++Id, Position, Description, StartedOn, EndedOn, Posture, Repetitif',

            securites: '++Id, EntreeZone, DureeExposition, EPI, IsPose, MoyenObservation',

            cassettes: '++Id, Reference, TypeTetePrelevement, RefTetePrelevement, Integrite, DureePrelevement, *PlageHoraireIds, PompeId',
            plageHoraires: '++Id, Debut, Fin',
            pompes: '++Id, Reference, Bluetooth, ElectriciteAccessible, DebitInitial, DebitFinal, CompteurVolInitial, CompteurVolFinal, CompteurHoraireInitial, CompteurHoraireFinal',

            pointageJournaliers: '++Id, DepartDomicile, DebutJournee, FinJournee, ArriveeDomicile, *PointagePauseIds',
            pointagePauses: '++Id, Debut, Fin',
        });

        this.interventionRepository = new InterventionRepository(this);
        this.userRepository = new UserRepository(this);
        this.samplingPointRepository = new SamplingPointRepository(this);
        this.zoneRepository = new ZoneRepository(this);
        this.zoneMeasureRepository = new ZoneMeasureRepository(this);
        this.cassetteRepository = new CassetteRepository(this);
        this.mpcaRepository = new MpcaRepository(this);
        this.zoneSamplingConditionRepository = new ZoneSamplingConditionRepository(this);
        this.plageHoraireRepository = new PlageHoraireRepository(this);
        this.pompeRepository = new PompeRepository(this);
        this.processRepository = new ProcessRepository(this);
        this.meanOfPreventionRepository = new MeanOfPreventionRepository(this);
        this.processCalculationRepository = new ProcessCalculationRepository(this);
        this.processTechniqueRepository = new ProcessTechniqueRepository(this);
        this.processMeasureRepository = new ProcessMeasureRepository(this);
        this.globalTaskRepository = new GlobalTaskRepository(this);
        this.processSamplingConditionRepository = new ProcessSamplingConditionRepository(this);
        this.operatorRepository = new OperatorRepository(this);
        this.taskRepository = new TaskRepository(this);
        this.securiteRepository = new SecuriteRepository(this);
        this.pointageRepository = new PointageRepository(this);
        this.areaMapRepository = new AreaMapRepository(this);
        this.measureMassifRepository = new MeasureMassifRepository(this);
        this.measureEauRepository = new MeasureEauRepository(this);
        this.measureLingetteRepository = new MeasureLingetteRepository(this);
        this.measureAdductionRepository = new MeasureAdductionRepository(this);
        this.materielAdductionRepository = new MaterielAdductionRepository(this);
        this.prelevementAirRepository = new PrelevementAirRepository(this);
        this.measureGenericRepository = new MeasureGenericRepository(this);

        // this.on('populate', () => this.populate()); // populate event happens at the first opening of the db
        this.open()
            .catch(e => {
                return this.handleError(e);
            });
    }

    async populate() {
        // await db.transaction('rw', db.interventions, db.pictures, async () => {

        //     const lastRiskId = await db.pictures.bulkAdd([
        //         {
        //             Code: 'RCode1',
        //             Name: 'Rat',
        //             PictogramName: 'ATEX'
        //         },
        //         {
        //             Code: 'RCode2',
        //             Name: 'Raton',
        //             PictogramName: 'ATEX'
        //         },
        //         {
        //             Code: 'RCode4',
        //             Name: 'Ratoune',
        //             PictogramName: 'ATEX'
        //         }
        //     ]);
        //     const lastIdentifiedRIskId = await db.pictures.bulkAdd([
        //         {
        //             // riskAnalysisId,
        //             Position: 1,
        //             Comment: 'Feed the birds',
        //             // otherMeanOfPreventionDescription: ''
        //             RiskId: lastRiskId - 2
        //         },
        //         {
        //             // riskAnalysisId,
        //             Position: 2,
        //             Comment: 'Watch a movie',
        //             RiskId: lastRiskId - 1
        //         },
        //         {
        //             // riskAnalysisId,
        //             Position: 3,
        //             Comment: 'Have some sleep',
        //             RiskId: lastRiskId
        //         }
        //     ]);

        //     const ra1 = await db.riskAnalysis.add({
        //         Code: 'RACocode1',
        //         Status: 1,
        //         IdentifiedRiskEntityIds: [lastIdentifiedRIskId - 2, lastIdentifiedRIskId - 1]
        //     });
        //     const ra2 = await db.riskAnalysis.add({
        //         Code: 'RACocode2',
        //         Status: 1,
        //         IdentifiedRiskEntityIds: [lastIdentifiedRIskId]
        //     });

        //     await db.interventions.add({
        //         Code: 1234,
        //         RedactorPUID: 'FNR8',
        //         RiskAnalysisId: ra1
        //     });

        //     await db.interventions.add({
        //         Code: 12345,
        //         RedactorPUID: 'HE4I',
        //         RiskAnalysisId: ra2
        //     });
        // });
    }

    async resetDatabase() {
        await db.transaction('rw', [
            db.interventions, db.samplingPoints, db.zones, db.mpcas, db.mesures, db.cassettes, db.plageHoraires,
            db.pompes, db.meanOfPreventions, db.process, db.processSamplingConditions, db.operators, db.processMeasures, db.globalTasks,
            db.tasks, db.securites, db.zoneSamplingConditions, db.processTechniques, db.processCalculations,
            db.pointageJournaliers, db.pointagePauses, db.users, db.areaMaps,
            db.measureMassif, db.measureEau, db.materielEau, db.measureLingette,
            db.materielAdduction, db.measureAdduction, db.prelevementAir, db.measureGeneric], async () => {

                await this.interventions.clear();
                await this.samplingPoints.clear();
                await this.zones.clear();
                await this.mpcas.clear();
                await this.mesures.clear();
                await this.cassettes.clear();
                await this.plageHoraires.clear();
                await this.pompes.clear();
                await this.meanOfPreventions.clear();
                await this.process.clear();
                await this.processMeasures.clear();
                await this.processSamplingConditions.clear();
                await this.operators.clear();
                await this.globalTasks.clear();
                await this.tasks.clear();
                await this.securites.clear();
                await this.zoneSamplingConditions.clear();
                await this.processTechniques.clear();
                await this.processCalculations.clear();
                await this.pointageJournaliers.clear();
                await this.pointagePauses.clear();
                await this.users.clear();
                await this.areaMaps.clear();
                await this.measureMassif.clear();
                await this.measureEau.clear();
                await this.materielEau.clear();
                await this.measureLingette.clear();
                await this.measureAdduction.clear();
                await this.materielAdduction.clear();
                await this.prelevementAir.clear();
                await this.measureGeneric.clear();
            })
    }

    async changeInterventionStatus(int: Intervention) {
        return this.interventionRepository.changeInterventionStatus(int);
    }

    // #region INTERVENTION
    async addIntervention(int: Intervention) {
        return this.interventionRepository.addIntervention(int);
    }

    async getInterventionEntityById(id: number) {
        return this.interventionRepository.getInterventionEntityById(id);
    }

    async getInterventionEntityByCode(code: number) {
        return this.interventionRepository.getInterventionEntityByCode(code);
    }

    async getInterventionList() {
        return this.interventionRepository.getInterventionList();
    }

    async getInterventionByCode(code: number) {
        return this.interventionRepository.getInterventionByCode(code);
    }

    // async getInterventionWithOnlyContactByCode(code: number,) {
    //     return await db.interventions.where('Code').equals(code).first(async ie => {
    //         const intervention = mapper.map(ie, InterventionEntity, Intervention);

    //         if (ie?.LingetteIds) {
    //             for (let i = 0; i < ie.LingetteIds.length; i++) {
    //                 intervention.MesureLingetteList.push(await this.getMeasureLingetteById(ie.LingetteIds[i]));
    //             }
    //         }

    //         return intervention;
    //     })
    // }

    async getInterventionWithLingettes(code: number) {
        return this.interventionRepository.getInterventionWithLingettes(code);
    }

    async deleteIntervention(code: number) {
        return this.interventionRepository.deleteIntervention(code);
    }
    // #endregion INTERVENTION

    // #region USER

    async getUserById(id: number) {
        return this.userRepository.getUserById(id);
    }

    async attachUser(user: User, intId: number, forSampler: boolean) {
        return this.userRepository.attachUser(user, intId, forSampler);
    }

    // #endregion USER

    // #region SAMPLING POINT
    async getSamplingPointById(samplingPointId: number) {
        return this.samplingPointRepository.getSamplingPointById(samplingPointId);
    }

    async attachSamplingPoint(sp: SamplingPoint, intId: number) {
        return this.samplingPointRepository.attachSamplingPoint(sp, intId);
    }
    // #endregion

    //#region ZONE

    async updateZoneForConformity(zone: Zone) {
        return this.zoneRepository.updateZoneForConformity(zone);
    }

    async getZoneEntityByCode(code: string, isDepose: boolean) {
        return this.zoneRepository.getZoneEntityByCode(code, isDepose);
    }

    async getZoneEntityById(id: number) {
        return this.zoneRepository.getZoneEntityById(id);
    }

    async getZoneByIdWithChildren(id: number) {
        return this.zoneRepository.getZoneByIdWithChildren(id);
    }

    async getZoneByCodeWithChildren(code: string, isDepose: boolean) {
        return this.zoneRepository.getZoneByCodeWithChildren(code, isDepose);
    }

    async attachZone(zone: Zone, interventionId: number) {
        return this.zoneRepository.attachZone(zone, interventionId);
    }

    //#endregion

    //#region MEASURE
    async getZoneMeasureEntityById(id: number) {
        return this.zoneMeasureRepository.getZoneMeasureEntityById(id);
    }

    async getZoneMeasureEntityByCode(code: string, isDepose: boolean) {
        return this.zoneMeasureRepository.getZoneMeasureEntityByCode(code, isDepose);
    }

    async getZoneMeasureByIdWithChildren(id: number) {
        return this.zoneMeasureRepository.getZoneMeasureByIdWithChildren(id);
    }

    async getZoneMeasureByCodeWithChildren(code: string, isDepose: boolean) {
        return this.zoneMeasureRepository.getZoneMeasureByCodeWithChildren(code, isDepose);
    }

    async attachMeasure(measure: ZoneMeasure, zoneId: number) {
        return this.zoneMeasureRepository.attachMeasure(measure, zoneId);
    }

    async updateMeasure(measure: ZoneMeasure) {
        return this.zoneMeasureRepository.updateMeasure(measure);
    }

    async clearZoneMeasureWithChildren(measure: ZoneMeasure) {
        return this.zoneMeasureRepository.clearZoneMeasureWithChildren(measure);
    }

    async cancelledZoneMeasure(measure: ZoneMeasure, reason: string) {
        return this.zoneMeasureRepository.cancelledZoneMeasure(measure, reason);
    }
    //#endregion

    //#region CASSETTE

    async getCassetteEntityById(id: number) {
        return this.cassetteRepository.getCassetteEntityById(id);
    }

    async getCassetteByIdWithChildren(id: number) {
        return this.cassetteRepository.getCassetteByIdWithChildren(id);
    }

    async attachCassette(cassette: Cassette, measureId: number) {
        return this.cassetteRepository.attachCassette(cassette, measureId);
    }

    async attachCassetteToOperator(cassette: Cassette, operatorId: number) {
        return this.cassetteRepository.attachCassetteToOperator(cassette, operatorId);
    }

    //#endregion

    //#region MPCA

    async clearMPCAById(ids: number[]) {
        return this.mpcaRepository.clearMPCAById(ids);
    }

    async getMPCAEntityById(id: number) {
        return this.mpcaRepository.getMPCAEntityById(id);
    }

    async addMPCAToZone(zone: Zone, isDepose: boolean, mpca: MPCA) {
        return this.mpcaRepository.addMPCAToZone(zone, isDepose, mpca);
    }

    async attachMPCAToZone(mpca: MPCA, zoneId: number) {
        return this.mpcaRepository.attachMPCAToZone(mpca, zoneId);
    }

    async attachMPCAToProcess(mpca: MPCA, processTechniqueId: number) {
        return this.mpcaRepository.attachMPCAToProcess(mpca, processTechniqueId);
    }
    //#endregion

    //#region Sampling Condition
    async getSamplingConditionEntityById(id: number) {
        return this.zoneSamplingConditionRepository.getSamplingConditionEntityById(id);
    }

    async attachSamplingCondition(condition: ZoneSamplingCondition, measureId: number) {
        return this.zoneSamplingConditionRepository.attachSamplingCondition(condition, measureId);
    }
    //#endregion

    //#region Plage
    async getPlageHoraireEntityById(id: number) {
        return this.plageHoraireRepository.getPlageHoraireEntityById(id);
    }

    async clearPlageHoraireById(ids: number[]) {
        return this.plageHoraireRepository.clearPlageHoraireById(ids);
    }

    async attachPlageHoraire(plageHoraire: PlageHoraire, cassetteId: number) {
        return this.plageHoraireRepository.attachPlageHoraire(plageHoraire, cassetteId);
    }
    //#endregion

    //#region POMPE

    async getPompeEntityById(id: number) {
        return this.pompeRepository.getPompeEntityById(id);
    }

    async attachPompe(pompe: Pompe, cassetteId: number) {
        return this.pompeRepository.attachPompe(pompe, cassetteId);
    }

    //#endregion

    //#region PROCESS
    async getProcessEntityById(id: number) {
        return this.processRepository.getProcessEntityById(id);
    }

    async getProcessEntityByCode(code: string) {
        return this.processRepository.getProcessEntityByCode(code);
    }

    // async getProcessEntityWithProcessCalculationByCode(code: string) {
    //     return await db.process.where('Code').equals(code).first(async pe => {
    //         if (pe?.ProcessCalculationId) {
    //             p.ProcessCalculation = await db.getProcessCalculationById(pe.ProcessCalculationId);
    //         }
    //         return pe;
    //     });
    // }

    async getProcessByIdWithChildren(id: number) {
        return this.processRepository.getProcessByIdWithChildren(id);
    }

    async attachProcess(process: Process, interventionId: number) {
        return this.processRepository.attachProcess(process, interventionId);
    }
    //#endregion

    async updateProcessForConformity(process: Process) {

        let pe = await this.getProcessEntityByCode(process.Code);
        mapper.mutate(process, pe, Process, ProcessEntity);
        if (!pe || !pe.Id)
            return;

        await this.clearProcessTechniqueById(pe.ProcessTechniqueIds!);
        if (pe.MeanOfPreventionIds)
            await this.clearMeanOfPreventById(pe.MeanOfPreventionIds);
        pe.MeanOfPreventionIds = [];
        pe.ProcessTechniqueIds = [];
        await db.process.update(pe.Id, pe);

        if (process.ProcessTechniqueList && process.ProcessTechniqueList.length > 0) {
            for (let i = 0; i < process.ProcessTechniqueList.length; i++) {
                await this.attachProcessTechnique(process.ProcessTechniqueList[i], pe.Id);
            }
        }

        if (process.EnvCollectiveMeansOfPreventionList && process.EnvCollectiveMeansOfPreventionList.length > 0) {
            for (let i = 0; i < process.EnvCollectiveMeansOfPreventionList.length; i++) {
                await this.attachMeanOfPrevention(process.EnvCollectiveMeansOfPreventionList[i], pe.Id);
            }
        }
        return true;
    }

    async updateSamplingMode(processCode: string, samplingMode: ESamplingMode) {
        let pe = await this.getProcessEntityByCode(processCode);

        if (!pe || !pe.ProcessCalculationId) {
            return;
        }
        await db.processCalculations.update(pe?.ProcessCalculationId, {
            SamplingMode: samplingMode
        });
        return true;
    }

    //#region Mean Of Prevention
    async clearMeanOfPreventById(ids: number[]) {
        return this.meanOfPreventionRepository.clearMeanOfPreventById(ids);
    }

    async getMeanOfPreventionById(id: number) {
        return this.meanOfPreventionRepository.getMeanOfPreventionById(id);
    }

    async attachMeanOfPrevention(processTechnique: MeanOfPrevention, processId: number) {
        return this.meanOfPreventionRepository.attachMeanOfPrevention(processTechnique, processId);
    }
    //#endregion

    //#region PROCESS Calculation
    async getProcessCalculationById(id: number) {
        return this.processCalculationRepository.getProcessCalculationById(id);
    }

    async attachProcessCalculation(processTechnique: ProcessCalculation, processId: number) {
        return this.processCalculationRepository.attachProcessCalculation(processTechnique, processId);
    }

    //#endregion

    //#region PROCESS TECHNIQUE
    async clearProcessTechniqueById(ids: number[]) {
        return this.processTechniqueRepository.clearProcessTechniqueById(ids);
    }

    async getProcessTechniqueByIdWithChildren(id: number) {
        return this.processTechniqueRepository.getProcessTechniqueByIdWithChildren(id);
    }

    async attachProcessTechnique(processTechnique: ProcessTechnique, processId: number) {
        return this.processTechniqueRepository.attachProcessTechnique(processTechnique, processId);
    }
    //#endregion

    //#region PROCESS MEASURE

    async getProcessMeasureEntityById(id: number) {
        return this.processMeasureRepository.getProcessMeasureEntityById(id);
    }

    async getProcessMeasureEntityByCode(code: string) {
        return this.processMeasureRepository.getProcessMeasureEntityByCode(code);
    }

    async getProcessMeasureByIdWithChildren(id: number) {
        return this.processMeasureRepository.getProcessMeasureByIdWithChildren(id);
    }

    async getProcessMeasureByCodeWithChildren(code: string) {
        return this.processMeasureRepository.getProcessMeasureByCodeWithChildren(code);
    }

    // async updateProcessMeasure(measure: ProcessMeasure) {

    //     let pme = await this.getProcessMeasureEntityByCode(measure.Code);
    //     if (!pme || !pme.Id) {
    //         return false;
    //     }

    //     // if (pme.OperatorIds)
    //     //     await this.clearOperatorById(pme.OperatorIds)
    //     // for (let i = 0; i < measure.ProcessOperatorList.length; i++) {

    //     //     for (let j = 0; j < measure.ProcessOperatorList[i].CassetteList.length; j++) {
    //     for (let i = 0; pme.OperatorIds && i <  pme.OperatorIds?.length!; i++) {
    //         let oe = await this.getOperatorEntityById(pme?.OperatorIds[i]);

    //         for (let j = 0; oe?.CassetteIds && j < oe?.CassetteIds?.length!; j++) {
    //             let ce = await this.getCassetteEntityById(oe?.CassetteIds[j]);

    //             for (let k = 0; k < measure.ProcessOperatorList[i].CassetteList[j].PlageHoraireList.length; k++) {

    //                 if (measure.ProcessOperatorList[i].CassetteList[j].PlageHoraireList?.length > 0) {
    //                     const newPhArray: number[] = [];
    //                     if (ce?.PlageHoraireIds) {
    //                         await this.clearPlageHoraireById(ce.PlageHoraireIds)
    //                         await db.cassettes.update(ce.Id, { PlageHoraireIds: [] })
    //                     }
    //                     for (let i = 0; i < measure.Cassette.PlageHoraireList.length; i++) {
    //                         const phe = mapper.map(measure.Cassette.PlageHoraireList[i], PlageHoraire, PlageHoraireEntity);
    //                         const phId = await db.plageHoraires.add(phe);
    //                         newPhArray.push(phId);
    //                     }
    //                     ope.PlageHoraireIds = newPhArray
    //                 }
    //                 mapper.mutate(measure.Cassette, ope, Cassette, CassetteEntity);
    //                 await db.cassettes.update(pme.CassetteId, ope);
    //             }
    //         }
    //     }

    //     if (pme.ProcessSamplingConditionId) {
    //         const sce = await this.getProcessSamplingConditionEntityById(pme.ProcessSamplingConditionId);
    //         if (!sce) {
    //             return false;
    //         }
    //         mapper.mutate(measure.ProcessSamplingCondition, sce, ProcessSamplingCondition, ProcessSamplingConditionEntity);
    //         await db.processSamplingConditions.update(pme.ProcessSamplingConditionId, sce);
    //     }

    //     if (pme.SecuriteId) {
    //         const dse = await this.getSecuriteEntityById(pme.SecuriteId);
    //         if (!dse) {
    //             return false;
    //         }
    //         mapper.mutate(measure.Securite, dse, Securite, SecuriteEntity);
    //         await db.securites.update(pme.SecuriteId, dse);
    //     }

    //     mapper.mutate(measure, pme, ProcessMeasure, ProcessMeasureEntity);
    //     await db.processMeasures.update(pme.Id, pme);

    //     return true;
    // }

    async attachProcessMeasure(measure: ProcessMeasure, processId: number) {
        return this.processMeasureRepository.attachProcessMeasure(measure, processId);
    }

    async clearProcessMeasureChildren(measure: ProcessMeasure) {
        return this.processMeasureRepository.clearProcessMeasureChildren(measure);
    }

    async attachProcessMeasureNewChildByCode(measure: ProcessMeasure) {
        return this.processMeasureRepository.attachProcessMeasureNewChildByCode(measure);
    }

    async cancelledProcessMeasure(measure: ProcessMeasure, reason: string) {
        return this.processMeasureRepository.cancelledProcessMeasure(measure, reason);
    }
    //#endregion

    //#region GLOBAL TASK
    async clearGlobalTaskById(ids: number[]) {
        return this.globalTaskRepository.clearGlobalTaskById(ids);
    }

    async getGlobalTaskEntityById(id: number) {
        return this.globalTaskRepository.getGlobalTaskEntityById(id);
    }

    async getGlobalTaskListByProcessMeasureCode(processCode: string) {
        return this.globalTaskRepository.getGlobalTaskListByProcessMeasureCode(processCode);
    }

    async attachGlobalTask(task: GlobalTask, processId: number) {
        return this.globalTaskRepository.attachGlobalTask(task, processId);
    }

    async addGlobalTask(task: GlobalTask, processCode: string) {
        return this.globalTaskRepository.addGlobalTask(task, processCode);
    }
    //#endregion

    //#region Process Sampling Condition
    async getProcessSamplingConditionEntityById(id: number) {
        return this.processSamplingConditionRepository.getProcessSamplingConditionEntityById(id);
    }

    async attachProcessSamplingCondition(measure: ProcessSamplingCondition, measureId: number) {
        return this.processSamplingConditionRepository.attachProcessSamplingCondition(measure, measureId);
    }
    //#endregion

    //#region OPERATOR

    async getOperatorEntityById(id: number) {
        return this.operatorRepository.getOperatorEntityById(id);
    }

    async getOperatorByIdWithChildren(id: number) {
        return this.operatorRepository.getOperatorByIdWithChildren(id);
    }

    // async getOperatorEntityByCode(firstName: string, lastName: string) {
    //     return await db.operators.where('FirstName').equals(firstName).and(x => { return x.LastName === lastName }).first(async ze => {
    //         return ze;
    //     });
    // }

    async attachOperator(operator: Operator, measureId: number) {
        return this.operatorRepository.attachOperator(operator, measureId);
    }

    async deleteOperator(process: ProcessMeasure, op: Operator) {
        return this.operatorRepository.deleteOperator(process, op);
    }

    // TODO ADD CASCADE !!!!!!!!!!!!!!!!!! FFWEF WEUFHWEFH IUWEFH IUWFUE
    async clearOperatorById(ids: number[]) {
        return this.operatorRepository.clearOperatorById(ids);
    }
    //#endregion

    //#region TASK
    async clearTaskyId(ids: number[]) {
        return this.taskRepository.clearTaskyId(ids);
    }

    async attachTask(task: Task, operatorId: number) {
        return this.taskRepository.attachTask(task, operatorId);
    }

    //#endregion

    //#region SECURITE
    async getSecuriteEntityById(id: number) {
        return this.securiteRepository.getSecuriteEntityById(id);
    }

    async attachSecuriteToZone(securite: Securite, isPose: boolean, zoneMeasureId: number) {
        return this.securiteRepository.attachSecuriteToZone(securite, isPose, zoneMeasureId);
    }

    async attachSecuriteToProcess(securite: Securite, processMeasureId: number) {
        return this.securiteRepository.attachSecuriteToProcess(securite, processMeasureId);
    }

    //#endregion

    //#region POINTAGE

    async getPointageJournalierEntityById(id: number) {
        return this.pointageRepository.getPointageJournalierEntityById(id);
    }

    async addPointageJournalier(pointage: PointageJournalier) {
        return this.pointageRepository.addPointageJournalier(pointage);
    }

    async attachPointagePause(pause: PointagePause, pointageJournalierId: number) {
        return this.pointageRepository.attachPointagePause(pause, pointageJournalierId);
    }

    //#endregion

    //#region MAP

    async clearAreaMapById(ids: number[]) {
        return this.areaMapRepository.clearAreaMapById(ids);
    }

    async getAreaMapEntityById(id: number) {
        return this.areaMapRepository.getAreaMapEntityById(id);
    }

    async getAreaMapById(id: number) {
        return this.areaMapRepository.getAreaMapById(id);
    }

    async updateAreaMap(areaMapId: number, jsonContent: string, outputData: string) {
        return this.areaMapRepository.updateAreaMap(areaMapId, jsonContent, outputData);
    }

    async attachAreaMapToZone(areaMap: AreaMap, zoneId: number) {
        return this.areaMapRepository.attachAreaMapToZone(areaMap, zoneId);
    }

    async attachAreaMapToProcess(areaMap: AreaMap, processId: number) {
        return this.areaMapRepository.attachAreaMapToProcess(areaMap, processId);
    }

    async attachAreaMapToIntervention(areaMap: AreaMap, interventionId: number) {
        return this.areaMapRepository.attachAreaMapToIntervention(areaMap, interventionId);
    }

    async attachLingetteAreaMapTerrain(lingetteAreaMapTerrain: AreaMap, interventionId: number) {
        return this.areaMapRepository.attachLingetteAreaMapToIntervention(lingetteAreaMapTerrain, interventionId);
    }
    //#endregion

    //#region Measure Massif

    async getMeasureMassifById(id: number) {
        return this.measureMassifRepository.getMeasureMassifById(id);
    }

    async getMeasureMassifEntityByCode(code: string) {
        return this.measureMassifRepository.getMeasureMassifEntityByCode(code);
    }

    async getMeasureMassifByCode(code: string) {
        return this.measureMassifRepository.getMeasureMassifByCode(code);
    }

    async attachMeasureMassif(measure: MeasureMassif, interventionId: number) {
        return this.measureMassifRepository.attachMeasureMassif(measure, interventionId);
    }

    async updateMeasureMassif(measure: MeasureMassif) {
        return this.measureMassifRepository.updateMeasureMassif(measure);
    }

    async cancelMeasureMassif(measure: MeasureMassif, reason: string) {
        return this.measureMassifRepository.cancelMeasureMassif(measure, reason);
    }
    //#endregion

    //#region Measure Eau
    async getMeasureEauEntityByCode(code: string) {
        return this.measureEauRepository.getMeasureEauEntityByCode(code);
    }

    async getMaterielEauEntityById(id: number) {
        return this.measureEauRepository.getMaterielEauEntityById(id);
    }

    async getMeasureEauByCode(code: string) {
        return this.measureEauRepository.getMeasureEauByCode(code);
    }

    async getMeasureEauById(id: number) {
        return this.measureEauRepository.getMeasureEauById(id);
    }

    async attachMeasureEau(measure: MeasureEau, interventionId: number) {
        return this.measureEauRepository.attachMeasureEau(measure, interventionId);
    }

    async attachMaterielEau(measure: MaterielEau, eauId: number) {
        return this.measureEauRepository.attachMaterielEau(measure, eauId);
    }

    async updateMeasureEau(measure: MeasureEau) {
        return this.measureEauRepository.updateMeasureEau(measure);
    }

    async cancelMeasureEau(measure: MeasureEau, reason: string) {
        return this.measureEauRepository.cancelMeasureEau(measure, reason);
    }
    //#endregion

    //#region Measure Lingette

    async getMeasureLingetteEntityByCode(code: string) {
        return this.measureLingetteRepository.getMeasureLingetteEntityByCode(code);
    }

    async getMeasureLingetteById(id: number) {
        return this.measureLingetteRepository.getMeasureLingetteById(id);
    }

    async getMeasureLingetteByCode(code: string) {
        return this.measureLingetteRepository.getMeasureLingetteByCode(code);
    }

    async attachMeasureLingette(measure: MeasureLingette, interventionId: number) {
        return this.measureLingetteRepository.attachMeasureLingette(measure, interventionId);
    }

    async updateMeasureLingette(measure: MeasureLingette) {
        return this.measureLingetteRepository.updateMeasureLingette(measure);
    }

    async cancelLingette(measure: MeasureLingette, reason: string) {
        return this.measureLingetteRepository.cancelLingette(measure, reason);
    }
    //#endregion

    //#region Measure ADDUCTION

    async getMesureAdductionEntityByCode(code: string) {
        return this.measureAdductionRepository.getMesureAdductionEntityByCode(code);
    }

    async getMesureAdductionEntityById(id: number) {
        return this.measureAdductionRepository.getMesureAdductionEntityById(id);
    }

    async getMesureAdductionByCodeWithChildren(code: string) {
        return this.measureAdductionRepository.getMesureAdductionByCodeWithChildren(code);
    }

    async getMesureAdductionByIdWithChildren(id: number) {
        return this.measureAdductionRepository.getMesureAdductionByIdWithChildren(id);
    }

    async attachMesureAdduction(measure: MesureAdduction, interventionId: number) {
        return this.measureAdductionRepository.attachMesureAdduction(measure, interventionId);
    }

    async updateMeasureAdduction(measure: MesureAdduction) {
        return this.measureAdductionRepository.updateMeasureAdduction(measure);
    }

    async cancelAdduction(measure: MesureAdduction, reason: string) {
        return this.measureAdductionRepository.cancelAdduction(measure, reason);
    }

    //#endregion

    //#region MATERIEL ADDUCTION

    async getMaterielAdductionEntityByCode(code: string) {
        return this.materielAdductionRepository.getMaterielAdductionEntityByCode(code);
    }

    async getMaterielAdductionById(id: number) {
        return this.materielAdductionRepository.getMaterielAdductionById(id);
    }

    async attachMaterielAdduction(measure: MaterielAdduction, adductionId: number) {
        return this.materielAdductionRepository.attachMaterielAdduction(measure, adductionId);
    }
    async clearMaterielAdductionById(ids: number[]) {
        return this.materielAdductionRepository.clearMaterielAdductionById(ids);
    }
    //#endregion

    //#region PRELEVEMENT AIR

    async getPrelevementAirEntityByCode(code: string) {
        return this.prelevementAirRepository.getPrelevementAirEntityByCode(code);
    }

    async getPrelevementAirById(id: number) {
        return this.prelevementAirRepository.getPrelevementAirById(id);
    }

    async attachPrelevementAir(measure: PrelevementAir, adductionId: number) {
        return this.prelevementAirRepository.attachPrelevementAir(measure, adductionId);
    }

    async clearPrelevementAirById(ids: number[]) {
        return this.prelevementAirRepository.clearPrelevementAirById(ids);
    }
    //#endregion

    // #region GENERICS
    async getMesureGenericEntityByCode(code: string) {
        return this.measureGenericRepository.getMesureGenericEntityByCode(code);
    }

    async getMesureGenericByCode(code: string) {
        return this.measureGenericRepository.getMesureGenericByCode(code);
    }

    async getMesureGenericById(id: number) {
        return this.measureGenericRepository.getMesureGenericById(id);
    }

    async attachGeneric(measure: MeasureGeneric, interventionId: number) {
        return this.measureGenericRepository.attachGeneric(measure, interventionId);
    }

    async updateMeasureGeneric(measure: MeasureGeneric) {
        return this.measureGenericRepository.updateMeasureGeneric(measure);
    }

    async cancelGeneric(measure: MeasureGeneric, reason: string) {
        return this.measureGenericRepository.cancelGeneric(measure, reason);
    }
    // #endregion

    async exportDB(cb: any) {
        const idbDatabase = db.backendDB();
        IDBExportImport.exportToJsonString(idbDatabase, cb);
    }

    importDB(jsonString: any) {
        const idbDatabase = db.backendDB();
        db.resetDatabase
        IDBExportImport.clearDatabase(idbDatabase, function (err: any) {
            if (!err) {
                IDBExportImport.importFromJsonString(idbDatabase, jsonString, function (err: any) {
                    if (!err) {
                        console.log('Imported data successfully');
                    }
                });
            }
        });
    }

    handleError(e: any): any {
        switch (e.name) {
            case 'AbortError':
                if (e.inner) {
                    return this.handleError(e.inner);
                }
                console.error('Abort error ' + e.message);
                break;
            case 'QuotaExceededError':
                console.error('QuotaExceededError ' + e.message);
                break;
            default:
                console.error(e);
                break;
        }
    }
}

export const db = new AppDB();
